import { URL } from '../constants';
import { opsApiInstance } from '../instance';

import { SendCheckoutMailRequest } from './types';

export const sendCheckoutMail = (body: SendCheckoutMailRequest) =>
  opsApiInstance.post(URL.SEND_CHECKOUT_MAIL, body);
